module.exports = __webpack_public_path__ + "static/media/soa-web-portal.670c2a54.png";